var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateDocBlue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.48 50.21a1.82 1.82 0 0 0 3.57.71l4.8-24.62a7 7 0 0 0-5.61-8.3l-23.89-4.7-.51-2.66a7.22 7.22 0 0 0-8.57-5.51L20.64 12.1a1.57 1.57 0 0 0-1.12.72L5.54 33A1.87 1.87 0 0 0 5 34.68l10.64 53.94a7.25 7.25 0 0 0 8.58 5.61l30.11-5.82a1.77 1.77 0 1 0-.72-3.47L23.5 90.76a3.63 3.63 0 0 1-4.29-2.86L8.9 35.7l9.91-1.94a7.27 7.27 0 0 0 5.71-8.48l-1.94-9.91L57 8.63a3.57 3.57 0 0 1 4.29 2.76c2.76 14 5.51 28.09 8.27 42.09a30.88 30.88 0 0 0-11.76 4.29c-3.88 3.06-5.92 6.64-4.49 11.74a55.47 55.47 0 0 0 12.55 22.27 10.6 10.6 0 0 0 15.21 0 54 54 0 0 0 12.66-22.37 10.44 10.44 0 0 0-4.59-11.64 28.75 28.75 0 0 0-16-4.5l-1.12-6 2 .41c2.35.41 3.06-3.06.71-3.47l-3.57-.82-1.63-8.78 9.29 1.73c2.34.41 2.85-3.06.61-3.57L68.72 30.8l-2.65-13.69 22.45 4.39a3.37 3.37 0 0 1 2.76 4ZM23.2 62.57c-2.25.41-1.54 4 .71 3.47l23.37-4.7a1.77 1.77 0 1 0-.71-3.47ZM59.33 45l-38.18 7.76c-2.24.41-1.53 3.88.72 3.47L60 48.47a1.77 1.77 0 1 0-.67-3.47Zm-2-9.91-38.12 7.76c-2.24.41-1.53 3.88.72 3.47L58 38.56a1.77 1.77 0 1 0-.71-3.47Zm11.94 42.8a3.42 3.42 0 0 0 4.9 0l8.53-8.79c1.64-1.63-.91-4.18-2.55-2.55l-8.37 8.79-4-4c-1.63-1.63-4.18.92-2.55 2.56Zm-51.18-47.6-7.25 1.32L19.62 19l1.43 7a3.76 3.76 0 0 1-3 4.29ZM87.2 60.73a6.8 6.8 0 0 1 3.06 7.76 50.71 50.71 0 0 1-11.74 20.84 7.3 7.3 0 0 1-10.11 0 50.6 50.6 0 0 1-11.63-20.84 6.55 6.55 0 0 1 3-7.66 25.66 25.66 0 0 1 27.46-.1Z",
    fill: "#45586b",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateDocBlue2);
export default __webpack_public_path__ + "static/media/corporate-doc-blue-2.09c4e82792396bc370b21b6275ffd649.svg";
export { ForwardRef as ReactComponent };